import React, { useContext } from 'react';
import T from 'prop-types';
import { RefScrollableWrapper } from '../ui-helpers/scrollable-wrapper';

export const PopoverWithContext = ({
  component: Component,
  ...rest
}) => {
  const scrollableWrapper = useContext(RefScrollableWrapper);

  return (
    <Component
      getPopupContainer={() =>
        scrollableWrapper || document.querySelector('body')}
      getCalendarContainer={() =>
        scrollableWrapper || document.querySelector('body')}
      {...rest}
    />
  );
};

PopoverWithContext.propTypes = {
  component: T.oneOfType([T.node, T.func]).isRequired,
};



// WEBPACK FOOTER //
// ./src/components/popovers/popover-with-context.js